import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'components/Grid';

import { imageCardSizeDefault } from 'utils/helpers/entities';

import styles from '../styles.module.scss';

import StyledContentEntities from './StyledContentEntities';

const checkEntityByType = (entities, types, typeWithSubTypes) =>
	!!entities.find(
		(entity) =>
			types.includes(entity.type) ||
			typeWithSubTypes.secondaryTypes.includes(
				entity[typeWithSubTypes.mainType]?.type
			)
	);

const checkHasOnlyPortraitCards = (entities) => {
	const portraitCardTypes = ['book', 'person', 'promoBlock'];
	const portraitCardWithSubTypes = {
		mainType: 'movie',
		secondaryTypes: ['movie', 'performance']
	};

	return checkEntityByType(
		entities,
		portraitCardTypes,
		portraitCardWithSubTypes
	);
};

const checkHasOnlyLandscapeCards = (entities) => {
	const landscapeCardTypes = [
		'article',
		'event',
		'institute',
		'object',
		'poem',
		'promoBlock'
	];
	const landscapeCardWithSubTypes = {
		mainType: 'movie',
		secondaryTypes: ['broadcast', 'lecture']
	};

	return checkEntityByType(
		entities,
		landscapeCardTypes,
		landscapeCardWithSubTypes
	);
};

const getEntitiesParams = (entities) => {
	if (checkHasOnlyPortraitCards(entities)) {
		return {
			gridParams: {
				colMobileIphoneXs: 2,
				colMobileMedium: 3,
				colMobileLarge: 4
			},
			paramsImage: imageCardSizeDefault.portrait
		};
	}

	if (checkHasOnlyLandscapeCards(entities)) {
		return {
			gridParams: {
				colMobileIphoneXs: 2,
				colMobileLarge: 3
			},
			paramsImage: imageCardSizeDefault.landscape
		};
	}

	return {
		gridParams: {
			colMobileIphoneXs: 2,
			colMobileLarge: 3
		},
		paramsImage: imageCardSizeDefault.landscape
	};
};

const StyledContentGroup = ({ items }) => {
	const existingEntities = items.filter((item) => item[item.type].title);
	const { gridParams, paramsImage } = getEntitiesParams(existingEntities);

	return (
		<Grid className={styles.gridCards} {...gridParams}>
			{_(existingEntities).map((item, index) => (
				<StyledContentEntities
					// eslint-disable-next-line react/no-array-index-key
					key={item[item.type]._id + index}
					type={item.type}
					item={item[item.type]}
					index={index}
					paramsImage={paramsImage}
				/>
			))}
		</Grid>
	);
};

StyledContentGroup.propTypes = {
	items: PropTypes.array.isRequired
};

export default StyledContentGroup;
